import { render, staticRenderFns } from "./CollectionsNavigator.vue?vue&type=template&id=0f4d45f0&scoped=true&"
import script from "./CollectionsNavigator.vue?vue&type=script&lang=js&"
export * from "./CollectionsNavigator.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsNavigator.vue?vue&type=style&index=0&id=0f4d45f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d45f0",
  null
  
)

export default component.exports